import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { cn } from '@/lib/styles';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: 'small' | 'large';
}
const Input = React.forwardRef<HTMLInputElement, InputProps>((t0, ref) => {
  const $ = _c(17);
  let className;
  let props;
  let t1;
  let type;
  if ($[0] !== t0) {
    ({
      className,
      type,
      variant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = type;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    type = $[4];
  }
  const variant = t1 === undefined ? "large" : t1;
  let t2;
  let t3;
  let t4;
  if ($[5] !== className || $[6] !== ref || $[7] !== type || $[8] !== variant) {
    const sizeStyles = {
      small: "h-10",
      large: "h-11"
    };
    t2 = type;
    t3 = ref;
    t4 = cn("flex w-full py-3.5 text-lg border-neutral-light-500 bg-transparent rounded-sm px-3 shadow-xs transition-colors file:border-0 file:bg-transparent file:text-base file:font-medium placeholder:text-neutral-dark/40 text-neutral-dark focus:border-neutral-light-600 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50", sizeStyles[variant], className);
    $[5] = className;
    $[6] = ref;
    $[7] = type;
    $[8] = variant;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
  }
  let t5;
  if ($[12] !== props || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <input type={t2} ref={t3} className={t4} {...props} />;
    $[12] = props;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
});
Input.displayName = 'Input';
export { Input };